import { useContext } from 'react';
import { AppContext } from '../context';
import { URL_BASE_CHAT } from '../config/endpoints';
import { dateToStringFormat } from '../utils/formatters';
import { findContact } from '../utils/utils';

const buildParam = (key, value) => `${encodeURIComponent(`${key}: `)}${value}`;

const getProductLabel = productId => {
  if (!productId) {
    return '';
  }
  if (productId === 225){
    return 'Mensal';
  }
  return 'Único';
};
const getPaymentValue = (titleValue, titleAmount) => {
  if (!titleValue || !titleAmount) {
    return '';
  }

  return parseInt(titleValue, 10) * parseInt(titleAmount, 10);
};

const chatHandler = (baseParams, otherParams, host) => {
  window.open(
    `${host}${baseParams}&cotacao=${otherParams}`,
    '_blank',
    'width=795, height=590, top=100, left=699, status=no, toolbar=no, menubar=no, resizable=no, fullscreen=no'
  );
};

const baseParams = (
  name = 'VISITANTE',
  email = 'VISITANTE@VISITANTE.COM.BR',
  phone = '111111111'
) =>
  [
    buildParam('name', name),
    buildParam('email', email),
    buildParam('phone', phone),
  ].join(encodeURIComponent('; '));
const personParams = (
  personType = '',
  name = '',
  email = '',
  cellphone = '',
  residencePhone = '',
  commercialPhone = '',
  cpf = '',
  birthdate = '',
  sex = '',
  maritalState = '',
  profession = '',
  cep = '',
  individualIncome = '',
  familyIncome = ''
) =>
  [
    buildParam('Tipo de pessoa', personType),
    buildParam('Nome', name),
    buildParam('E-mail', email),
    buildParam('Telefone Celular', cellphone),
    buildParam('Telefone Residencial', residencePhone),
    buildParam('Telefone Comercial', commercialPhone),
    buildParam('CPF', cpf),
    buildParam('Data Nascimento', birthdate),
    buildParam('Sexo', sex),
    buildParam('Estado Civil', maritalState),
    buildParam('Profissao', profession),
    buildParam('CEP', cep),
    buildParam('Renda Individual', individualIncome),
    buildParam('Renda Familiar', familyIncome),
  ].join(encodeURIComponent('; '));

const productParams = (
  productId = '',
  paymentType = '',
  titleValue = '',
  titleAmount = '',
  paymentValue = ''
) =>
  [
    buildParam('Codigo do Produto', productId),
    buildParam('Tipo de pagamento', paymentType),
    buildParam('Valor do titulo', titleValue),
    buildParam('Qtd de titulos', titleAmount),
    buildParam('Valor a pagar', paymentValue),
  ].join(encodeURIComponent('; '));

const simulationParams = currentDate =>
  [
    buildParam(
      'Data da simluacao',
      `${currentDate.getDate()}/${currentDate.getMonth() +
        1}/${currentDate.getFullYear()}`
    ),
    buildParam(
      'Hora da simulacao',
      `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`
    ),
  ].join(encodeURIComponent('; '));
const useChatLink = () => {
  const { userData, productData } = useContext(AppContext);

  const getChatLink = () =>
    `${personParams(
      userData?.pessoa?.identificacao.tipo,
      userData?.pessoa?.nome,
      findContact('PES', userData?.pessoa?.comunicacao.parametros),
      findContact('CEL', userData?.pessoa?.comunicacao.parametros),
      findContact('RES', userData?.pessoa?.comunicacao.parametros),
      findContact('COM', userData?.pessoa?.comunicacao.parametros),
      userData?.pessoa?.identificacao?.codigo,
      dateToStringFormat(
        userData?.pessoa?.dadosPessoaFisica.dataNascimento ?? ''
      ),
      userData?.pessoa?.dadosPessoaFisica.sexo.codigo,
      userData?.pessoa?.dadosPessoaFisica.estadoCivil.valor,
      userData?.pessoa?.dadosPessoaFisica.profissao.valor,
      userData?.pessoa?.endereco.cep,
      userData?.pessoa?.informacoesEconomicas.faixaRenda[1].descricao,
      userData?.pessoa?.informacoesEconomicas.faixaRenda[0].descricao
    )}${encodeURIComponent('; ')}${buildParam(
      'Pagina de origem',
      'Autocompra CAP Ganhador'
    )}${encodeURIComponent('; ')}${productParams(
      productData?.oferta.identificacao.codigoProduto,
      getProductLabel(productData?.oferta.identificacao.codigoProduto),
      productData?.itemCapitalizacao.titulos[0].planosTitulos.valor,
      productData?.itemCapitalizacao.titulos[0].planosTitulos.titulo,
      getPaymentValue(
        productData?.itemCapitalizacao.titulos[0].planosTitulos.valor,
        productData?.itemCapitalizacao.titulos[0].planosTitulos.titulo
      )
    )}${encodeURIComponent('; ')}${simulationParams(new Date())}`;

  const getBaseParams = () =>
    `${baseParams(
      userData?.pessoa?.nome,
      findContact('PES', userData?.pessoa?.comunicacao.parametros),
      findContact('CEL', userData?.pessoa?.comunicacao.parametros)
    )}`;

  const callChat = () => {
    chatHandler(getBaseParams(), getChatLink(), URL_BASE_CHAT);
  };
  const chatURL = () =>
    `${URL_BASE_CHAT}${getBaseParams()}&cotacao=${getChatLink()}`;
  return { callChat, chatURL };
};
export default useChatLink;
